
<template>
  <div class="ApplyUserDialog">
    <!-- 申请人员选择设置弹窗 -->
    <el-dialog
      class="timeDialog1"
      title="申请人配置"
      :visible="applyUserDiaVisible"
      :before-close="closeDialog"
      :close-on-click-modal="false"
    >
      <div class="maskBox">
        <div class="maskContent">
          <div class="tableList">
            <el-row>
              <el-col :span="12">
                <div class="tableItem">
                  <div class="menuTitlePanel">部门</div>
                  <el-tree
                    empty-text="暂无数据"
                    :expand-on-click-node="true"
                    :props="defaultProps"
                    :load="loadNode"
                    node-key="id"
                    @node-click="handleNodeClick"
                    highlight-current
                    lazy
                  ></el-tree>
                </div>
              </el-col>
              <el-col :span="12">
                <!-- <div class="brnList">
               <img @click="addCheckList" src="@/assets/images/contract/leftBtn.png" alt />
              <img @click="delCheckList" src="@/assets/images/contract/rightBtn.png" alt />
                </div>-->
                <div class="tableItem">
                  <el-table
                    :data="approveRYList"
                    ref="multipleTable1"
                    width="100%"
                    highlight-current-row
                    @current-change="handleRYListChange"
                  >
                    <template slot="empty">
                      <p></p>
                    </template>
                    <!-- <el-table-column type="selection" width="55"></el-table-column> -->
                    <el-table-column prop="displayName" label="人员姓名"></el-table-column>
                  </el-table>
                </div>
              </el-col>
            </el-row>
          </div>
          <div slot="footer" class="dialog-footer">
             <el-button type="info" @click="closeDialog">关 闭</el-button>
            <el-button type="primary" @click="saveApproveRYBtn">保 存</el-button>           
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getProjectGMListService, //获取相应部门人员列表
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
export default {
  name: "ApplyUserDialog",
  props: {
    applyUserName: {
      type: String
    },
    applyUserDiaVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      departList: {
        applyUserName: "",
        applyUserId: "",
        applyDeptId: "",
        applyDeptName: ""
      }, //申请人模板数组
      deptSelected: [], //选中的节点
      isShowMaskBox: false, //配置弹窗是否可见
      choiceindex: 0, //记录选择的索引值
      approveBMList: [], //部门列表
      approveRYList: [], //人员列表
      selectedApproveRY: {}, //选中的人员对象
      defaultProps: {
        id: "id",
        label: "name",
        isLeaf: "leaf",
        children: "children"
      }
    };
  },
  methods: {
    // 加载树结点
    loadNode(node, resolve) {
      // 如果是顶级的父节点
      if (node.level === 0) {
        // 查找顶级对象
        let reqParam = {
          pid: 0,
          orgId: sessionStorage.getItem("orgId")
        };
        getDeptListService(reqParam)
          .then(res => {
            if (res.code == 10000000) {
              return resolve(res.data);
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定"
              });
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      } else {
        // 根据父节点id找寻下一级的所有节点
        let param = {};
        param.deptId = node.data.id;
        getsubDeptService(param)
          .then(res => {
            if (res.code == 10000000) {
              let nodes = res.data;
              nodes.forEach(item => {
                item.leaf = item.isLeaf == 1;
              });
              return resolve(nodes);
            } else {
              this.$message.error(res.Msg);
            }
          })
          .catch(() => {
            let data = [];
            return resolve(data);
          });
      }
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId")
      };
      getDeptListService(reqParam).then(
        res => {
          if (res.code == 10000000) {
            // this.total = res.total;
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        },
        err => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定"
          });
        }
      );
    },
    /* 菜单点击回调事件 */
    handleNodeClick(deptNode) {
      // this.deptSelected = deptNode;
      this.departList.applyDeptId = deptNode.id;
      this.departList.applyDeptName = deptNode.name;
      this.getProjectGMList(deptNode.id);
    },
    //点击部门文本框触发事件
    ShowMaskBoxFun(val = 1) {
      this.choiceindex = val;
      this.isShowMaskBox = true;
    },
    //获取审批列表项目经理下拉框数据
    getProjectGMList(deptId) {
      let param = {
        deptId: deptId,
        jobId: 0
      };
      getProjectGMListService(param)
        .then(res => {
          if (res.code == 10000000) {
            this.approveRYList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定"
            });
          }
        })
        .catch(error => {});
    },
    //选中人员事件
    handleRYListChange(val) {
      this.selectedApproveRY = val;
      console.log(val);
    },

    closeDialog() {
      this.approveRYList = [];
      this.$emit("close");
    },
    //保存审批人员
    saveApproveRYBtn(val = 0) {
      if ("" != this.selectedApproveRY.id) {
        this.departList.applyUserName = this.selectedApproveRY.displayName;
        this.departList.applyUserId = this.selectedApproveRY.id;
        this.departList.phone = this.selectedApproveRY.phone;
        this.departList.signUrl = this.selectedApproveRY.signUrl;
        
        this.applyUserDiaVisible = false;
        this.approveRYList = [];
        this.$emit("SaveApplyUser", this.departList);
      } else {
        this.$alert("您尚未选择申请人", "提示", {
          confirmButtonText: "确定"
        });
      }
    },
    //保存审批流部门审批人员列表
    saveApproveLine() {
      // let newdepartList=[];
      for (let i = 0; i < this.departList.length; i++) {
        delete this.departList[i].type;
      }
      //  console.log(newdepartList);
      this.$emit("saveApproveLine", this.departList);
    },
    //重置审批人员列表
    clearShowMaskBox() {
      this.departList.map(item => {
        item.approveUserId = "";
        item.approveUserName = "";
        item.deptId = "";
        item.deptName = "";
      });
      // let arr = [...this.departList];
      // this.departList = [];
      // this.departList = arr;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";

.ApplyUserDialog{
        .timeDialog1 {
            /deep/ .el-dialog {
                width: 40%;
                height: 70%;

                .el-dialog__header {
                    height: 24px;
                }

                .el-dialog__body {
                    height: calc(100% - 114px);
                }
            }

            .maskBox {
                width: 100%;
                height: 100%;
                overflow: hidden;

                .maskContent {
                    width: 100%;
                    height: 100%;
                    overflow: hidden;

                    .tableList {
                        height: calc(100% - 46px);

                        .el-row {
                            height: 100%;

                            .el-col-12 {
                                width: 46%;
                                margin: 0 2%;
                            }

                            .el-col {
                                height: 100%;


                                .tableItem {
                                    height: 100%;
                                    overflow: hidden;
                                    border: 1px solid #ebeef5;

                                    .menuTitlePanel {
                                        height: 49px;
                                        line-height: 50px;
                                        text-indent: 10px;
                                        text-align: left;
                                        border-bottom: 1px solid #ebeef5;
                                    }

                                    .el-tree {
                                        height: calc(100% - 50px);
                                        overflow: auto;
                                        text-align: left;
                                    }

                                    /deep/ .el-tree > .el-tree-node {
                                        display: inline-block !important;
                                        min-width: 51%;
                                    }

                                    /deep/ .el-table {
                                        height: 100%;

                                        th, th.is-leaf {
                                            background-color: #fff !important;
                                        }

                                        th > .cell {
                                            font-size: 14px;
                                            color: #444444;
                                        }

                                        .el-table__body-wrapper {
                                            height: calc(100% - 50px);
                                            overflow: auto;
                                            tr td{
                                                padding: 8px 0;
                                            }
                                        }
                                    }
                                }
                            }
                        }

                    }
                    .dialog-footer {
                        height: 36px;
                        padding-top: 10px;
                        text-align: center;
                    }
                }
            }
        }
    }
</style>
